import { css } from 'styled-components';

export default css`
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
`;
